// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-spinner {
    width: 50px;
    height: 50px;
    border: 10px solid #D50C2F; /* Light grey */
    border-top: 10px solid #383636; /* Blue */
    border-radius: 50%;
    animation: spinner 1.5s linear infinite;
    margin-left: 150px;
    margin-top: 15px;
    z-index: 1;
    position: absolute;
  }
  
.spinner-container {
  position: fixed;
  background: #00000050;
  width: 100%;
  height: 500vh;
  top: 0;
  left: 0;
  z-index: 1;
}

.box1 {
  position: relative;
  width: 25%;
  margin: 0 auto;
  height: 150px;
  max-height: 70vh;
  margin-top: 300px;
  background: #fff;
  border-radius: 25px;
  padding: 20px;
  border: 1px solid #999;
  overflow: auto;
  margin-left: 400px;
}



@media screen and (max-width: 1400px) {
  .box1 {
    width: 30%;
  }

}

@media screen and (max-width: 900px) {
  .box1 {
    margin-left: 280px;
  }

}


@media screen and (max-width: 1300px) {
  .loading-spinner {
    margin-left: 38%;
  }

}

@media screen and (min-width: 1300px) {
  .loading-spinner {
    margin-left: 37%;
  }
}

@media screen and (min-width: 1400px) {
  .loading-spinner {
    margin-left: 39%;
  }
}

@media screen and (min-width: 1700px) {
  .loading-spinner {
    margin-left: 38%;
  }
}

@media screen and (min-width: 1900px) {
  .loading-spinner {
    margin-left: 37%;
  }
}

@media screen and (min-width: 1300px) {
  .box1{
      left: 100px;

  }
}

@media screen and (min-width: 1500px) {
  .box1{
      left: 175px;

  }
}

@media screen and (min-width: 1700px) {
.box1{
    left: 260px;
    width: 23%;
}
}

@media screen and (min-width: 1900px) {
.box1{
    left: 375px;
    width: 20%;
}
}

@media screen and (min-width: 2101px) {
.box1{
    left: 27%;
    width: 18%;
}
}

@media screen and (min-width: 2300px) {
.box1{
  left: 29%;
  width: 17%;
}
}


.loadhead {
  margin-top: 100px;
}`, "",{"version":3,"sources":["webpack://./src/styles/spinner.css"],"names":[],"mappings":"AAAA;IACI;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,0BAA0B,EAAE,eAAe;IAC3C,8BAA8B,EAAE,SAAS;IACzC,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;EACpB;;AAEF;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;;;AAIA;EACE;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,kBAAkB;EACpB;;AAEF;;;AAGA;EACE;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;MACI,WAAW;;EAEf;AACF;;AAEA;EACE;MACI,WAAW;;EAEf;AACF;;AAEA;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;;AAEA;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;;AAEA;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;;AAEA;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;;;AAGA;EACE,iBAAiB;AACnB","sourcesContent":["@keyframes spinner {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .loading-spinner {\n    width: 50px;\n    height: 50px;\n    border: 10px solid #D50C2F; /* Light grey */\n    border-top: 10px solid #383636; /* Blue */\n    border-radius: 50%;\n    animation: spinner 1.5s linear infinite;\n    margin-left: 150px;\n    margin-top: 15px;\n    z-index: 1;\n    position: absolute;\n  }\n  \n.spinner-container {\n  position: fixed;\n  background: #00000050;\n  width: 100%;\n  height: 500vh;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.box1 {\n  position: relative;\n  width: 25%;\n  margin: 0 auto;\n  height: 150px;\n  max-height: 70vh;\n  margin-top: 300px;\n  background: #fff;\n  border-radius: 25px;\n  padding: 20px;\n  border: 1px solid #999;\n  overflow: auto;\n  margin-left: 400px;\n}\n\n\n\n@media screen and (max-width: 1400px) {\n  .box1 {\n    width: 30%;\n  }\n\n}\n\n@media screen and (max-width: 900px) {\n  .box1 {\n    margin-left: 280px;\n  }\n\n}\n\n\n@media screen and (max-width: 1300px) {\n  .loading-spinner {\n    margin-left: 38%;\n  }\n\n}\n\n@media screen and (min-width: 1300px) {\n  .loading-spinner {\n    margin-left: 37%;\n  }\n}\n\n@media screen and (min-width: 1400px) {\n  .loading-spinner {\n    margin-left: 39%;\n  }\n}\n\n@media screen and (min-width: 1700px) {\n  .loading-spinner {\n    margin-left: 38%;\n  }\n}\n\n@media screen and (min-width: 1900px) {\n  .loading-spinner {\n    margin-left: 37%;\n  }\n}\n\n@media screen and (min-width: 1300px) {\n  .box1{\n      left: 100px;\n\n  }\n}\n\n@media screen and (min-width: 1500px) {\n  .box1{\n      left: 175px;\n\n  }\n}\n\n@media screen and (min-width: 1700px) {\n.box1{\n    left: 260px;\n    width: 23%;\n}\n}\n\n@media screen and (min-width: 1900px) {\n.box1{\n    left: 375px;\n    width: 20%;\n}\n}\n\n@media screen and (min-width: 2101px) {\n.box1{\n    left: 27%;\n    width: 18%;\n}\n}\n\n@media screen and (min-width: 2300px) {\n.box1{\n  left: 29%;\n  width: 17%;\n}\n}\n\n\n.loadhead {\n  margin-top: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
